function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { HTML_ATTRIBUTE_BLOCKER_CONNECTED, HTML_ATTRIBUTE_VISUAL_PARENT } from ".";
import { render } from "react-dom";
import { WebsiteBlocker } from "../../components";
import { getSsrPoweredByLink } from "..";
import { HTML_ATTRIBUTE_BLOCKER_ID } from "./manipulateDom";
import { getPreviousVisibleElement } from "../../utils";
import { probablyResetParentContainerForContentBlocker } from ".";
var connectedCounter = 0;
/**
 * Create visual content blocker for a given node.
 */

function createContentBlocker(_ref) {
  var _node$style, _createBefore$parentE, _createBefore$parentE2, _createBefore$parentE3;

  var node = _ref.node,
      blocker = _ref.blocker;
  // Visual content blockers are only allowed for "real" content
  var isPositioned = ["fixed", "absolute", "sticky"].indexOf((_node$style = node.style) === null || _node$style === void 0 ? void 0 : _node$style.position) > -1;
  var isNotInContent = [document.body, document.head, document.querySelector("html")].indexOf(node.parentElement) > -1;
  var isAlreadyConnected = node.getAttribute(HTML_ATTRIBUTE_BLOCKER_CONNECTED);

  if (isNotInContent || isPositioned || !(blocker !== null && blocker !== void 0 && blocker.visual) || isAlreadyConnected || !node.offsetParent && !blocker.forceHidden) {
    // Always hide elements (again) if no visual blocker is possible (get)
    if (["script", "link"].indexOf(node === null || node === void 0 ? void 0 : node.tagName.toLowerCase()) === -1) {
      node.style.display = "none";
    }

    return;
  } // Find element where the content blocker should be placed (e. g. a content blocker should be inside a link)


  var forceVisualParent = ["a"].indexOf(node.parentElement.tagName.toLowerCase()) > -1;
  var useVisualParent = node.hasAttribute(HTML_ATTRIBUTE_VISUAL_PARENT) || forceVisualParent;
  var createBefore = useVisualParent ? node.parentElement : node;
  var container = document.createElement("div"); // Avoid duplicate visual blockers and connect them

  var possibleDuplicates = [getPreviousVisibleElement(createBefore), createBefore.previousElementSibling, (_createBefore$parentE = createBefore.parentElement) === null || _createBefore$parentE === void 0 ? void 0 : _createBefore$parentE.previousElementSibling, (_createBefore$parentE2 = createBefore.parentElement) === null || _createBefore$parentE2 === void 0 ? void 0 : (_createBefore$parentE3 = _createBefore$parentE2.previousElementSibling) === null || _createBefore$parentE3 === void 0 ? void 0 : _createBefore$parentE3.lastElementChild].filter(Boolean);

  var _iterator = _createForOfIteratorHelper(possibleDuplicates),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var possibleDuplicate = _step.value;

      if (+possibleDuplicate.getAttribute(HTML_ATTRIBUTE_BLOCKER_ID) === blocker.id && possibleDuplicate.hasAttribute(HTML_ATTRIBUTE_BLOCKER_CONNECTED)) {
        node.setAttribute(HTML_ATTRIBUTE_BLOCKER_CONNECTED, possibleDuplicate.getAttribute(HTML_ATTRIBUTE_BLOCKER_CONNECTED));
        return;
      }
    } // Connect blocker with blocked node

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  container.setAttribute(HTML_ATTRIBUTE_BLOCKER_CONNECTED, connectedCounter.toString());
  container.setAttribute(HTML_ATTRIBUTE_BLOCKER_ID, blocker.id.toString());
  container.className = "rcb-content-blocker";
  node.setAttribute(HTML_ATTRIBUTE_BLOCKER_CONNECTED, connectedCounter.toString());
  createBefore.parentNode.insertBefore(container, createBefore); // Hide our element and render content blocker

  createBefore.style.display = "none";
  render(h(WebsiteBlocker, {
    poweredLink: getSsrPoweredByLink(),
    blocker: blocker
  }), container);
  connectedCounter++;
  probablyResetParentContainerForContentBlocker(createBefore, true);
}

export { createContentBlocker };